import { useCallback, useEffect, useState } from 'react';
import { getSubscription } from './subscription-api';
/** Loads the current user's subscription on mount; `reload()` refetches (e.g. after cancel). */
export function useSubscription() {
    const [state, setState] = useState({
        data: null,
        loading: true,
        error: false,
    });
    const reload = useCallback(() => {
        setState((s) => ({ ...s, loading: true }));
        getSubscription()
            .then((data) => setState({ data, loading: false, error: false }))
            .catch(() => setState({ data: null, loading: false, error: true }));
    }, []);
    useEffect(() => {
        reload();
    }, [reload]);
    return { ...state, reload };
}
